<template>
    <div
        class="w-60 cardRegister container px-2 py-2 border border-secondary-subtle position-fixed top-50 start-50 translate-middle p-3">
        <button class="btn-close float-end me-2 mt-1" @click.prevent="close"></button>
        <h4 class="mt-3"><strong>Registrar tramo completo</strong></h4>
        <form action="" class="w-75 mx-auto">
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="sheetDimType">Clasificación:</label>
                </div>
                <div class="col-sm-5">
                    <select class="form-select" id="sheetDimType" v-model="sheetDimType">
                        <option value="0" selected>Opciones disponibles...</option>
                        <option value="HR">HR</option>
                        <option value="CR">CR</option>
                        <option value="CORRUGADA / ALFAJOR">CORRUGADA ALFAJOR</option>
                        <option value="INOXIDABLE">INOXIDABLE</option>
                        <option value="ALUMINIO">ALUMINIO</option>
                        <option value="ANTIDESGASTE">ANTIDESGASTE</option>
                    </select>
                </div>
            </div>
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="sheetPstAndSpc">Presentación / Espefificación:</label>
                </div>
                <div class="col-sm-5">
                    <select class="form-select" id="sheetPstAndSpc" v-model="sheetPstAndSpc"
                        @change="trimPresentationAndSpecification(this.sheetPstAndSpc)">
                        <option value="0" selected>Seleccione una opción...</option>
                        <option value="LISA HR / ASTM A-36">LISA HR / ASTM A-36</option>
                        <option value="LISA CR / ASTM A-366">LISA CR / ASTM A-366</option>
                        <option value="LISA CR GALVANIZADA / ASTM A-366">LISA CR GALVANIZADA / ASTM A-366</option>
                        <option value="CORRUGADA (ALFAJOR) / ASTM A-589">CORRUGADA (ALFAJOR) / ASTM A-589</option>
                        <option value="LISA INOXIDABLE OPACA / AISI - SAE  304  T1">LISA INOXIDABLE OPACA / AISI - SAE 304
                            T1</option>
                        <option value="CURRUGADA (ALFAJOR) ALUMINIO / AISI - ASTM 6061">CURRUGADA (ALFAJOR) ALUMINIO / AISI
                            - ASTM 6061</option>
                        <option value="LISA ANTIDESGASTE / ASTM L2  MAXDUR  450 - 500">LISA ANTIDESGASTE / ASTM L2 MAXDUR
                            450 - 500</option>
                    </select>
                </div>
            </div>
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="sheetDimensions">Dimensiones:</label>
                </div>
                <div class="col-sm-5">
                    <input type="text" v-model="sheetDimensions" class="form-control" id="sheetDimensions" />
                </div>
            </div>
            <div class="row aling-items-center mt-3 mb-3">
                <div class="col-sm-5">
                    <label for="pricevalue">Precio asociado: </label>
                </div>
                <div class="col-sm-5">
                    <select class="form-select" id="price_id" v-model="priceId">
                        <option selected value="0">Opciones disponibles...</option>
                        <option v-for="price in pricesList" :key="price._id" v-bind:value="price.id">
                            {{ price.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div>
                <button class="btn btn-danger mb-2" @click.prevent="registerCompSection">
                    Guardar tramo completo
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    data() {
        return {
            priceDefault: "lam",
            pricesList: [],
            sheetDimType: "",
            sheetPstAndSpc: "",
            sheetPresentation: "",
            sheetSpecification: "",
            sheetDimensions: "",
            priceId: 0,
        };
    },
    methods: {
        trimPresentationAndSpecification(presentationSpecification) {
            let variables = presentationSpecification.split('/');
            this.sheetPresentation = variables[0].trim();
            this.sheetSpecification = variables[1].trim();
        },
        async registerCompSection() {
            if (
                this.sheetDimType === "" ||
                this.sheetPresentation === "" ||
                this.sheetSpecification === "" ||
                this.sheetDimensions === "" ||
                this.priceId === 0
            ) {
                alert("Alguno de los campos está vácio, complete aquellos que son obligatorios marcados con * para crear el tramo completo.");
            } else {
                let formData = new FormData();
                formData.append("type", this.sheetDimType);
                formData.append("presentation", this.sheetPresentation);
                formData.append("specification", this.sheetSpecification);
                formData.append("dimensions", this.sheetDimensions);
                formData.append("price_id", this.priceId);
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/sheet/dimension/create",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        alert("Tramo completo creado con exito");
                        this.cleanfields();
                        this.$emit("hidePopUp", false);
                        location.reload();
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
        },
        cleanfields() {
            this.sheetDimType = "0";
            this.sheetDimPresentation = "";
            this.pricevalue = 0;
        },
        close() {
            this.$emit("hidePopUp", false)
        },
    },
    mounted() {
        axios
            .get(RUTA_SERVIDOR + "api/price/list", {
                params: {
                    price_type: this.priceDefault,
                },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
            .then((res) => (this.pricesList = res.data))
            .catch((err) => console.log(`There has been an error ${err}`));
    },
};
</script>